import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6923372ee021be0014f7bf6a/bold_minimal_portfolio_1763915566073/src/app/about/components/AboutContent.tsx");
